"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CustomMarkdown: ()=>CustomMarkdown
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const horizon_namespaceObject = require("@pcln/horizon");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_react_markdown_namespaceObject = require("react-markdown");
var external_react_markdown_default = /*#__PURE__*/ __webpack_require__.n(external_react_markdown_namespaceObject);
const misc_js_namespaceObject = require("../../constants/misc.js");
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const StreamingStatusContext_js_namespaceObject = require("../../context/StreamingStatusContext.js");
const StreamingStatusProvider_js_namespaceObject = require("../../context/StreamingStatusProvider.js");
const external_CustomLink_js_namespaceObject = require("./CustomLink.js");
const CustomText = (props)=>{
    const isStreaming = external_react_default().useContext(StreamingStatusContext_js_namespaceObject.StreamingStatusContext);
    const { setiValues } = external_react_default().useContext(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { children, as = 'span', ...rest } = props;
    if (!isStreaming) {
        if ('p' === as) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.P, {
            ...rest,
            children: children
        });
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Span, {
            ...rest,
            children: children
        });
    }
    const animate = (text, per = 'word')=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.TextEffect, {
            as: as,
            per: per,
            preset: "fade",
            speedReveal: 1,
            speedSegment: 1,
            children: text
        });
    const processStringForStreaming = (text)=>{
        const lastBracketIndex = text.lastIndexOf('[');
        if (-1 === lastBracketIndex) return animate(text);
        const suffix = text.slice(lastBracketIndex);
        if (!suffix.includes('](')) return animate(text);
        const incompleteLinkRegex = /\[([^\]]*)\]\([^)]*$/;
        const match = incompleteLinkRegex.exec(text);
        if (match?.index !== void 0) {
            const textBeforeLink = text.substring(0, match.index);
            const linkText = match[1];
            const processedText = textBeforeLink + linkText;
            return animate(processedText);
        }
        return animate(text);
    };
    const processChildren = (childNodes)=>external_react_default().Children.map(childNodes, (child)=>{
            if ('string' == typeof child && child?.trim() !== '') return processStringForStreaming(child);
            return child;
        });
    return setiValues?.shouldEnableTextAnimation ? processChildren(children) : children;
};
const Header = ({ children })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Heading, {
        as: "h5",
        className: "mb-3",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomText, {
            children: children
        })
    });
const Paragraph = ({ children })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomText, {
        as: "p",
        textStyle: "body1",
        className: "mb-3",
        children: children
    });
const BoldText = ({ children })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomText, {
        textStyle: "body1",
        bold: true,
        children: children
    });
const HorizontalRule = ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "mb-3",
        children: '  '
    });
const ItalicText = ({ children })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomText, {
        italic: true,
        children: children
    });
const List = ({ children })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("ul", {
        className: "text-body1 mb-4 ml-6 list-disc",
        children: children
    });
const ListItem = ({ children })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("li", {
        className: "mb-1 mt-1",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomText, {
            children: children
        })
    });
const ProcessedLink = ({ href, children })=>{
    const { logCustomerCarePhoneNumberClicked } = external_react_default().useContext(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    let finalHref = href;
    if (!finalHref) {
        const childArray = external_react_default().Children.toArray(children);
        if (1 === childArray.length && 'string' == typeof childArray[0]) {
            const childString = childArray[0];
            const isRawPhoneNumber = /^\d[\d-.\s()]*$/.test(childString);
            if (isRawPhoneNumber) finalHref = `tel:${childString.replace(/\D/g, '')}`;
        }
    }
    const isRawPhoneNumberInHref = finalHref && !finalHref.startsWith('tel:') && /^\d[\d-.\s()]*$/.test(finalHref);
    if (isRawPhoneNumberInHref) finalHref = `tel:${finalHref?.replace(/\D/g, '')}`;
    const handleClick = ()=>{
        const cleanSupportNumber = misc_js_namespaceObject.COSTUMER_SUPPORT_NUMBER.replace(/\D/g, '');
        const cleanedHrefNumber = finalHref?.replace(/\D/g, '');
        if (cleanedHrefNumber === cleanSupportNumber && logCustomerCarePhoneNumberClicked && 'function' == typeof logCustomerCarePhoneNumberClicked) logCustomerCarePhoneNumberClicked();
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CustomLink_js_namespaceObject.CustomLink, {
        href: finalHref ?? '',
        onClick: handleClick,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomText, {
            children: children
        })
    });
};
const ImageComponent = ({ src, alt })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Image, {
        src: src,
        alt: alt,
        style: {
            display: 'inline-block',
            marginRight: '8px'
        },
        borderRadius: "xl",
        width: "120px",
        height: "90px"
    });
const CustomMarkdown = (props)=>{
    const { children, isStreaming = true } = props;
    const { logCustomerCarePhoneNumberDisplayed } = external_react_default().useContext(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const processedMarkdown = children?.replace(/(1?[-.]?\d{3}[-.]?\d{3}[-.]?\d{4})/g, (_, phoneNumber)=>{
        if (phoneNumber === misc_js_namespaceObject.COSTUMER_SUPPORT_NUMBER && logCustomerCarePhoneNumberDisplayed && 'function' == typeof logCustomerCarePhoneNumberDisplayed) logCustomerCarePhoneNumberDisplayed();
        const cleanNumber = phoneNumber?.replace(/\D/g, '');
        return `[${phoneNumber}](tel:${cleanNumber})`;
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(StreamingStatusProvider_js_namespaceObject.StreamingStatusProvider, {
        value: isStreaming,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_markdown_default(), {
            components: {
                a: ProcessedLink,
                b: BoldText,
                strong: BoldText,
                p: Paragraph,
                em: ItalicText,
                header: Header,
                h1: Header,
                h2: Header,
                h3: Header,
                h4: Header,
                h5: Header,
                h6: Header,
                img: ImageComponent,
                hr: HorizontalRule,
                br: HorizontalRule,
                ul: List,
                li: ListItem
            },
            children: processedMarkdown?.replace(/\\n/g, '\n')
        })
    });
};
exports.CustomMarkdown = __webpack_exports__.CustomMarkdown;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CustomMarkdown"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
